import state from './moduleWebstoreOrderState';
import mutations from './moduleWebstoreOrderMutations';
import actions from './moduleWebstoreOrderActions';
import getters from './moduleWebstoreOrderGetters';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
